import { render } from "./textaPendulumQinghai.vue?vue&type=template&id=372fbb84&scoped=true"
import script from "./textaPendulumQinghai.vue?vue&type=script&lang=js"
export * from "./textaPendulumQinghai.vue?vue&type=script&lang=js"

import "./textaPendulumQinghai.vue?vue&type=style&index=0&id=372fbb84&lang=scss&scoped=true"

import exportComponent from "D:\\lpl\\szy\\cloud-api-web-vue\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-372fbb84"]])

export default __exports__